// BANNER
export const TITLE = <div>Sales Specialist enablement</div>;

// INSTRUCTIONS
export const GOALS = "Learn how to create and develop sales strategies and craft proposals for potential clients.";
export const HOW = "The training is free and self-paced.";
export const WHAT = "You must successfully complete Sales enablement before starting this training.";
export const REQUIREMENTS = " Sales enablement must be successfully completed before starting Sales Specialist enablement.";

// BADGE
const SALES_COVER_1 = "Introduction to Dynatrace";
const SALES_COVER_2 = "Master the art of discovery";
const SALES_COVER_3 = "Discover latest sales plays";
const SALES_COVER_4 = "Identify partner opportunities";
export const SALES_COVERS: String[] = [SALES_COVER_1, SALES_COVER_2, SALES_COVER_3, SALES_COVER_4];

const SALES_SPECIALIST_COVER_1 = "Further explore latest sales plays";
const SALES_SPECIALIST_COVER_2 = "Demo and PoC Dynatrace";
const SALES_SPECIALIST_COVER_3 = "Licensing and DPS explained";
const SALES_SPECIALIST_COVER_4 = "Competition and market analysis";
export const SALES_SPECIALIST_COVERS: String[] = [SALES_SPECIALIST_COVER_1, SALES_SPECIALIST_COVER_2, SALES_SPECIALIST_COVER_3, SALES_SPECIALIST_COVER_4];


// ACHIEVEMENTS
export const ACHIEVEMENTS = <div >
                        ·&nbsp;&nbsp; Upon completion of this training, you will be able to position Dynatrace capabilities to 
                        land new deals and to expand your customer base. You will also know how to face the competition with the best 
                        Dynatrace differentiators, and how to license the solution for effective customer proposals.
                        {/* <br></br>
                        &nbsp;&nbsp;&nbsp;potential clients. */}
                        <br></br>
                        <br></br>
                        ·&nbsp;&nbsp; After completing a small quiz, you will be awarded the Dynatrace Partner Sales Specialist badge.
                    </div>;
// -- 


// FAQs
// export const TITLE_ONE = "What certifications are needed to be part of the Dynatrace partner program?";
// export const TITLE_TWO = "Is there any certification for a Salesperson?";

// export const SUB_TITLE_ONE = "According to the Dynatrace Partner program, each Partner needs to have 2 Core Partner Training certifications (which can be done by sales, pre-sales or post-sales resources) and 2 Associate certifications (which are technical).";
// export const SUB_TITLE_TWO = "Yes, the 'Core Partner' badge applies to Sales people. Just complete the “Core Partner Training”, and you will find a quiz at the end, which you will have to pass to gain the corresponding badge. This quiz can be done on your own, there is no need for a camera, and can be repeated if you do not achieve the needed grade.";


// --



